import {
  AccountProfessionalModel,
  UpdateAccountProfessionalModel
} from '@/domain/models/account/account-professional-model'

export interface AccountProfessional {
  get(accountId: string): Promise<AccountProfessional.Model>
  update(
    accountId: string,
    data: AccountProfessional.UpdateRequestModel
  ): Promise<AccountProfessional.Model>
}

export namespace AccountProfessional {
  export const Key = 'account-professional'
  export const UpdateKey = 'update-account-professional'
  export type Model = AccountProfessionalModel
  export type UpdateRequestModel = UpdateAccountProfessionalModel
}
